import React from 'react';
import { format as formatWith } from 'redux-form-validators';
import { isValidIBAN, electronicFormatIBAN } from 'ibantools';

import { IBAN_REGEX_LBP } from './constants';
import { IBAN_MAX_LENGTH } from '../../constants/form';

import InputFieldComponent from './InputFieldComponent';

const normalizeIban = value => {
    if (!value) {
        return value;
    }

    return electronicFormatIBAN(value);
};

class IBANInputFieldComponent extends React.Component {
    isIbanValid = value =>
        value && isValidIBAN(value) ? undefined : this.props.i18nFeatureForm.IBAN_INVALID;

    validateMandatory = () => [
        this.isIbanValid,
        formatWith({
            with: IBAN_REGEX_LBP,
            msg: this.props.i18nFeatureForm.IBAN_BANK_INVALID
        })
    ];

    render() {
        const { validate = [] } = this.props;
        return (
            <InputFieldComponent
                {...this.props}
                type="text"
                validate={[...this.validateMandatory(), ...validate]}
                normalize={normalizeIban}
                maxLength={IBAN_MAX_LENGTH}
            />
        );
    }
}

// See proptypes in ./InputFieldComponent.js for global Field props
export default IBANInputFieldComponent;



// WEBPACK FOOTER //
// ./src/components/form/IBANInputFieldComponent.js